
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiGateway } from 'cw-backend';
import { SnackBarService } from 'cw-utils';
import { QuotaLackControl } from '../../../models/accreditation/quotalackcontrol';

@Injectable()
export class QuotaLackControlEditProvider implements Resolve<any>
{
    routeParams: any;
    state: any;
    onDataChanged: BehaviorSubject<any>;
    quotaLackControl: QuotaLackControl;

    constructor(
        public gw: ApiGateway,
        public snackBar: SnackBarService
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        return new Promise((resolve, reject) => {
            Promise.all([this.getQuotaLackControl()]).then(
                () => {
                    resolve(true);
                },
                reject
            );
        });
    }

    getQuotaLackControl(): Promise<any> {
        return new Promise((resolve, reject) => {
            let data =  this.checkLastModifications()
            if (data && data.id == this.routeParams.id) {
                this.quotaLackControl = data;
                this.onDataChanged.next(this.quotaLackControl);
                resolve(this.quotaLackControl);
            } else if (this.routeParams.id === 'novo') {
                this.onDataChanged.next(false);
                resolve(false);
            }
            else {
                this.gw.get('quotaLackControl/' + this.routeParams.id).subscribe({next:(res: QuotaLackControl ) => {
                    this.quotaLackControl = res;
                    this.onDataChanged.next(this.quotaLackControl);
                    resolve(res);
                }, error: (err: any) => { reject(err) }});
            }
        });
    }

    insert(quotaLackControl): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('quotaLackControl/', quotaLackControl).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    checkQuotaLack(quotaLack): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('quotaLackControl/checkQuotaLack', quotaLack).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);                
            }, error: (err: any) => { reject(err) }});
        });
    }
    

    edit(quotaLackControl): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('quotaLackControl/', quotaLackControl).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    delete(quotaLackControl): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('quotaLackControl/' + quotaLackControl.id).subscribe({next:(response: HttpResponse<any>) => {
                resolve(response);
                 this.snackBar.successMessage(response.body.message);
            }, error: (err: any) => { reject(err) }});
        });
    }

    checkLastModifications(): QuotaLackControl {
        let wasLocked = JSON.parse(localStorage.getItem('session_locked'));
        let data;
        if (wasLocked){
            data = JSON.parse(localStorage.getItem('last_modification'));
            localStorage.removeItem('session_locked');
        }  
        return data;
    }
}
